import { CottonCandyContainer } from './CottonCandyContainer'
import { QuoteComplianceChecks } from './QuoteComplianceChecks'
import { QuoteCostBreakdown } from './QuoteCostBreakdown'
import { QuoteReviewButton } from './QuoteReviewButton'
import { QuoteSupportCard } from './QuoteSupportCard'

export function QuoteSidebar () {
  return (
    <div className='col-span-1'>
      <CottonCandyContainer>
        <QuoteCostBreakdown />
        <div className='p-6 space-y-4 rounded-b-2xl text-center'>
          <QuoteReviewButton />
          <p className='body-sm text-gray-500'>
            Numbers are estimates and will vary based on employee participation
            rates and the choices they make.
          </p>
        </div>
        <div className='border-t border-gray-200'>
          <div className='p-6'>
            <QuoteComplianceChecks />
          </div>
        </div>
      </CottonCandyContainer>
      <div className='mt-8'>
        <QuoteSupportCard />
      </div>
    </div>
  )
}
